export default defineNuxtPlugin(() => {
  const { isIntegrationEnabled } = useUtils()
  // Note: Segment is disabled by Default in useUtils()
  // So to run locally you will need to modify isDisabledInDev and isDisabledInPreview
  if (!isIntegrationEnabled('segment')) return

  // ===== Load the JS ==== //
  const segment = useSegmentHelper()
  const { $uiEvents, $sitewideConfig } = useNuxtApp()

  /* eslint-disable */
  // prettier-ignore
  !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.13.1";}}();
  /* eslint-enable */

  runOnNuxtReady(() => {
    if (typeof window.analytics?.load === 'function') window.analytics.load($sitewideConfig.config.segmentApiKey)
  })

  // ===== A promise to ensure that the JS is ready ==== //
  function _isReady() {
    return new Promise((resolve) => {
      window.analytics.ready(resolve)
    })
  }

  // ===== Exposed method to get the Segment Anonymous ID ==== //
  async function getAnonId() {
    await _isReady()
    return window.analytics.user().anonymousId()
  }

  // TODOLATER: We want to emit an Identify call on firstLoaded even
  // if we need to use an Anon ID.

  // =====  Wire up default events
  $uiEvents.$on('firstLoaded', (data) => segment.emitPage(data))
  $uiEvents.$on('firstLoaded', () => segment.emitIdentify())
  $uiEvents.$on('routeChanged', ({ to }) => segment.emitPage(to))
  $uiEvents.$on('amplitudeExposure', (exposure) => segment.track('$exposure', exposure))
  $uiEvents.$on('cmsLinkClicked', (obj) => segment.track('Clicked', obj))
  $uiEvents.$on('errorLog', ({ errorType }) => segment.track('Error Log', { errorType }))

  // TODOLATER: Emit device changed anymore? see 01.device.client.ts
  // $uiEvents.$on('deviceChanged', emitDeviceChanged) // Fires when deviceFromServer !== clientDevice

  // Wire up Listeners
  useSegmentCheckoutListener()
  useSegmentDealerLocatorListener()
  useSegmentExtendListener()
  useSegmentFitmentListener()
  useSegmentInstallernetListener()
  useSegmentMyAccountListener()
  useSegmentNavigationListener()
  useSegmentNewsletterListener()
  useSegmentProductsListener()
  useSegmentSaveCartListener()
  useSegmentSearchListener()

  return {
    provide: {
      segment: {
        getAnonId,
      },
    },
  }
})
